import styled from 'styled-components';
import * as grid from 'view/styles/grid';
import * as mixins from 'view/styles/mixins';

const Container = styled.div`
    ${mixins.flexCenter};
    justify-content: space-between;
    max-width: ${grid.unitless * 75}px;
    width: 100%;
    margin: 0 auto;
`;

export default Container;
